var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#808285",
    fillRule: "evenodd",
    d: "M8,0 C8.51283143,0 8.93550653,0.386039974 8.9932722,0.883378828 L9,1 L11,1 L11,2 L13,2 C13.51285,2 13.9355092,2.38604429 13.9932725,2.88337975 L14,3 L14,15 C14,15.51285 13.613973,15.9355092 13.1166239,15.9932725 L13,16 L3,16 C2.48716857,16 2.06449347,15.613973 2.0067278,15.1166239 L2,15 L2,3 C2,2.48716857 2.38604429,2.06449347 2.88337975,2.0067278 L3,2 L5,2 L5,1 L7,1 C7,0.447715 7.44772,0 8,0 Z M5,4 L4,4 L4,14 L12,14 L12,4 L11,4 L11,5 L5,5 L5,4 Z M7.99998,11 C8.55226,11 9,11.4477 9,12 C9,12.5523 8.55229,13 8,13 C7.44772,13 7,12.5523 7,12 C7,11.4477 7.4477,11 7.99998,11 Z M7.99998,6 C8.72576,6 9.22813,6.72492 8.97329,7.40449 L7.99998,11 L7.02666,7.40449 C6.77182,6.72492 7.27419,6 7.99998,6 Z M8,2 C7.44772,2 7,2.44772 7,3 C7,3.55228 7.44772,4 8,4 C8.55228,4 9,3.55228 9,3 C9,2.44772 8.55228,2 8,2 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.3477c4a39ffaafdf117771b6d461ff44.svg";
export { ForwardRef as ReactComponent };